import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "minus",
  "use": "minus-usage",
  "viewBox": "0 0 40 41",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 40 41\" id=\"minus\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M30.59 20.75a.75.75 0 0 1-.75.75H10.16a.75.75 0 0 1 0-1.5h19.68a.75.75 0 0 1 .75.75Z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol